import { computed, makeObservable } from 'mobx';
import {logger} from '../../../../lib/helpers';
import {ClassroomRole, SimplePeerSignal} from '../../models/classroom-models';
import {ClassroomTasks} from '../../stores/classroom-tasks';
import {ClassroomHubStore} from '../../stores/ClassroomHubStore';
import {UserMediaState} from '../models';

export class ClassroomStoreWrapper {
  constructor(readonly hub: ClassroomHubStore) {
    makeObservable(this);
  }

  get role(): ClassroomRole {
    return this.hub.role;
  }

  @computed
  get teacherConnectionId(): string | null {
    const state = this.hub.state.classroomState;
    return state === null ? null : state.TeacherConnectionId;
  }

  @computed
  get studentConnectionId(): string | null {
    const state = this.hub.state.classroomState;
    return state === null ? null : state.StudentConnectionId;
  }

  @computed
  get connectionPair(): string | null {
    const teacherConnectionId = this.teacherConnectionId;
    const studentConnectionId = this.studentConnectionId;
    if (teacherConnectionId === null || studentConnectionId === null)
      return null;
    return teacherConnectionId + ':' + studentConnectionId;
  }

  @computed
  get teacherMediaState(): UserMediaState {
    const state = this.hub.state.classroomState?.TeacherMediaState;
    if (state === null || state === undefined)
      return null;
    return JSON.parse(state);
  }

  @computed
  get studentMediaState(): UserMediaState {
    const state = this.hub.state.classroomState?.StudentMediaState;
    if (state === null || state === undefined)
      return null;
    return JSON.parse(state);
  }

  @computed
  get getLocalMediaState(): UserMediaState {
    return this.role === 'Student'
      ? this.studentMediaState
      : this.teacherMediaState;
  }

  simplePeerSignal = (teacher: string, student: string, data: any) => {
    logger.log('ClassroomStoreWrapper.onSignal');
    if (teacher !== this.teacherConnectionId || student !== this.studentConnectionId)
      return;

    const role = this.role;

    const signal: SimplePeerSignal = {
      From: role === 'Student' ? student : teacher,
      To: role === 'Student' ? teacher : student,
      Data: JSON.stringify(data)
    };
    this.hub.tasks.add(ClassroomTasks.simplePeerSignal(signal));
  };

  updateLocalMediaState = (state: UserMediaState) => {
    this.hub.tasks.add(ClassroomTasks.updateMediaState(state));
  };
}
